export let defaultOption = {
  url: `${window.location.origin}/`,
  apiUrl: `${window.location.origin}/api/pub/`,
  appId: "wx2221b616ef2ea5f1"
}
  
// export let defaultOption = {
//   url: "https://apph5.gjyymall.com/",
//   apiUrl: `https://apph5.gjyymall.com/api/pub/`,
//   appId: "wx2221b616ef2ea5f1"
// }

export let shareUrl: any = window.location.href


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/url.ts